let t={isLoading:!0,isAuthenticated:!1},e={redirectURL:"redirectURL"},i={logout:"/auth/logout"};export{e as STORAGE_KEYS,t as initialAuthState,i as routes};
//# sourceMappingURL=types.js.map